import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  maxOfnpw4mt1rg0hl as maxOf,
  minOf33o15vox9quzb as minOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  _ID___init__impl__k1lb7e3nwubwpb014i6 as _ID___init__impl__k1lb7e,
  $serializer_getInstances2uba6hlovkk as $serializer_getInstance,
  ID2ebczrc12h07k as ID,
  ID__toString_impl_y5cakadb8fzjf8iy39 as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulz34r5frdiblcos as ID__hashCode_impl_f4lulz,
} from './models.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  Multilinevduzy7shc6h7 as Multiline,
  Group209swmzf2sz2h as Group,
  Denormalized13y861o5nekmb as Denormalized,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { now2qufyxzn5e863 as now } from './clock.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  LocalDate31mqn6zavbpi8 as LocalDate,
  plus1et5dysousgt9 as plus_0,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { iterator3f5i676wpaa3g as iterator } from '../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance_1 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimeUnit.mjs';
import {
  contains21620uw5ew03f as contains,
  isEmpty2lvc2zgoeh0ds as isEmpty,
  ClosedRangehokgr73im9z3 as ClosedRange,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  PhoneNumberSerializer_getInstanceq35z0l42la4e as PhoneNumberSerializer_getInstance,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twlqkqzqu7p5mbp as PhoneNumber__hashCode_impl_t98twl,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  GeoCoordinateGeoJsonSerializer_getInstancew33zho1zb4lc as GeoCoordinateGeoJsonSerializer_getInstance,
  GeoCoordinate2xsokvzumk7qu as GeoCoordinate,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/GeoCoordinate.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1n9qg6fb0b5i8 as toString_1 } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.LocalDateRange', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('start', false);
        tmp0_serialDesc.addElement_5pzumi_k$('endInclusive', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_4dxp1j_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.start_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.endInclusive_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.endInclusive_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_4dxp1j_k$(encoder, value instanceof LocalDateRange() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LocalDateRange().new_org_thecommunitygroupinc_cares_LocalDateRange_i63meq_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalDateSerializer_getInstance(), get_nullable(LocalDateSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LocalDateRangeClass;
function LocalDateRange() {
  if (LocalDateRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        endInclusive = endInclusive === VOID ? null : endInclusive;
        this.start_1 = start;
        this.endInclusive_1 = endInclusive;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!(this.endInclusive_1 == null || this.endInclusive_1.compareTo_e7gwgq_k$(this.start_1) >= 0)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      contains_pio7lx_k$(value) {
        return value.compareTo_e7gwgq_k$(this.start_1) >= 0 && (this.endInclusive_1 == null || value.compareTo_e7gwgq_k$(this.endInclusive_1) <= 0);
      }
      overlaps_cm89fs_k$(other) {
        return (this.endInclusive_1 == null || this.endInclusive_1.compareTo_e7gwgq_k$(other.start_1) >= 0) && (other.endInclusive_1 == null || other.endInclusive_1.compareTo_e7gwgq_k$(this.start_1) >= 0);
      }
      overlap_uapg8u_k$(other) {
        var start = maxOf(this.start_1, other.start_1);
        var tmp0_safe_receiver = this.endInclusive_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = minOf(tmp0_safe_receiver, other.endInclusive_1);
        }
        var tmp1_elvis_lhs = tmp;
        var end = tmp1_elvis_lhs == null ? other.endInclusive_1 : tmp1_elvis_lhs;
        return end.compareTo_e7gwgq_k$(start) < 0 ? null : new (ClosedLocalDateRange())(start, end);
      }
      toString() {
        var tmp0_elvis_lhs = this.endInclusive_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return get_abbreviation(this.start_1.get_month_ivc8d3_k$()) + ' ' + this.start_1.day_1 + ', ' + this.start_1.year_1 + ' \u2013 ongoing';
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var end = tmp;
        return (new (ClosedLocalDateRange())(this.start_1, end)).toString();
      }
      copy_nazohw_k$(start, endInclusive) {
        return new (LocalDateRange())(start, endInclusive);
      }
      copy$default_iikz6e_k$(start, endInclusive, $super) {
        start = start === VOID ? this.start_1 : start;
        endInclusive = endInclusive === VOID ? this.endInclusive_1 : endInclusive;
        return $super === VOID ? this.copy_nazohw_k$(start, endInclusive) : $super.copy_nazohw_k$.call(this, start, endInclusive);
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + (this.endInclusive_1 == null ? 0 : this.endInclusive_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LocalDateRange()))
          return false;
        if (!this.start_1.equals(other.start_1))
          return false;
        if (!equals(this.endInclusive_1, other.endInclusive_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_LocalDateRange_i63meq_k$(seen0, start, endInclusive, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.start_1 = start;
        if (0 === (seen0 & 2))
          $this.endInclusive_1 = null;
        else
          $this.endInclusive_1 = endInclusive;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!($this.endInclusive_1 == null || $this.endInclusive_1.compareTo_e7gwgq_k$($this.start_1) >= 0)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'LocalDateRange', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    LocalDateRangeClass = $;
  }
  return LocalDateRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.Placeholder_1 = new (RecordedAction())(_ID___init__impl__k1lb7e(Companion_getInstance().NIL_1), Companion_getInstance_0().fromEpochMilliseconds_uaz65_k$(0n));
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.RecordedAction', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('by', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', true);
        tmp0_serialDesc.addElement_5pzumi_k$('reason', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Multiline())());
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_lfgj0b_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance(), new (ID())(value.by_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.at_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, InstantSerializer_getInstance(), value.at_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.reason_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.reason_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_lfgj0b_k$(encoder, value instanceof RecordedAction() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RecordedAction().new_org_thecommunitygroupinc_cares_RecordedAction_hkpy0n_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), InstantSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var RecordedActionClass;
function RecordedAction() {
  if (RecordedActionClass === VOID) {
    class $ {
      constructor(by, at, reason) {
        Companion_getInstance_3();
        at = at === VOID ? now() : at;
        reason = reason === VOID ? '' : reason;
        this.by_1 = by;
        this.at_1 = at;
        this.reason_1 = reason;
      }
      toString() {
        return 'RecordedAction(by=' + ID__toString_impl_y5caka(this.by_1) + ', at=' + this.at_1.toString() + ', reason=' + this.reason_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz(this.by_1);
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.reason_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RecordedAction()))
          return false;
        if (!equals(this.by_1, other.by_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.reason_1 === other.reason_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_RecordedAction_hkpy0n_k$(seen0, by, at, reason, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.by_1 = by;
        if (0 === (seen0 & 2))
          $this.at_1 = now();
        else
          $this.at_1 = at;
        if (0 === (seen0 & 4))
          $this.reason_1 = '';
        else
          $this.reason_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'RecordedAction', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    RecordedActionClass = $;
  }
  return RecordedActionClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ClosedLocalDateRange', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('start', false);
        tmp0_serialDesc.addElement_5pzumi_k$('endInclusive', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ls514k_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.start_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.endInclusive_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ls514k_k$(encoder, value instanceof ClosedLocalDateRange() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ClosedLocalDateRange().new_org_thecommunitygroupinc_cares_ClosedLocalDateRange_rlu0ea_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalDateSerializer_getInstance(), LocalDateSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ClosedLocalDateRange$iterator$slambda(this$0) {
  return constructCallableReference(($this$iterator, $completion) => orPromise($completion, function *($completion) {
    var current = this$0.start_1;
    while (current.compareTo_e7gwgq_k$(this$0.endInclusive_1) <= 0) {
      yield* $this$iterator.yield_3xhcex_k$(current, $completion);
      current = plus(current, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1));
    }
    return Unit_instance;
  }), 1);
}
var ClosedLocalDateRangeClass;
function ClosedLocalDateRange() {
  if (ClosedLocalDateRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this.start_1 = start;
        this.endInclusive_1 = endInclusive;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!(this.endInclusive_1.compareTo_e7gwgq_k$(this.start_1) >= 0)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      get_start_iypx6h_k$() {
        return this.start_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.endInclusive_1;
      }
      iterator_jk1svi_k$() {
        return iterator(ClosedLocalDateRange$iterator$slambda(this));
      }
      toString() {
        var startMonth = get_displayName(this.start_1.get_month_ivc8d3_k$());
        var endMonth = get_displayName(this.endInclusive_1.get_month_ivc8d3_k$());
        var sameMonth = this.start_1.year_1 === this.endInclusive_1.year_1 && this.start_1.get_month_ivc8d3_k$().equals(this.endInclusive_1.get_month_ivc8d3_k$());
        var lastDayOfEndMonth = plus_0(plus_0(LocalDate().new_kotlinx_datetime_LocalDate_rqj1zf_k$(this.endInclusive_1.year_1, this.endInclusive_1.get_month_ivc8d3_k$(), 1), 1, Companion_getInstance_1().MONTH_1), -1, Companion_getInstance_1().DAY_1);
        var isWholeMonth = sameMonth && this.start_1.day_1 === 1 && this.endInclusive_1.equals(lastDayOfEndMonth);
        return this.start_1.equals(this.endInclusive_1) ? startMonth + ' ' + this.start_1.day_1 + ', ' + this.start_1.year_1 : isWholeMonth ? startMonth + ' ' + this.start_1.year_1 : sameMonth ? startMonth + ' ' + this.start_1.day_1 + '-' + this.endInclusive_1.day_1 + ', ' + this.start_1.year_1 : this.start_1.year_1 === this.endInclusive_1.year_1 ? startMonth + ' ' + this.start_1.day_1 + ' - ' + endMonth + ' ' + this.endInclusive_1.day_1 + ', ' + this.start_1.year_1 : startMonth + ' ' + this.start_1.day_1 + ', ' + this.start_1.year_1 + ' - ' + endMonth + ' ' + this.endInclusive_1.day_1 + ', ' + this.endInclusive_1.year_1;
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + this.endInclusive_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClosedLocalDateRange()))
          return false;
        if (!this.start_1.equals(other.start_1))
          return false;
        if (!this.endInclusive_1.equals(other.endInclusive_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ClosedLocalDateRange_rlu0ea_k$(seen0, start, endInclusive, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.start_1 = start;
        $this.endInclusive_1 = endInclusive;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!($this.endInclusive_1.compareTo_e7gwgq_k$($this.start_1) >= 0)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
    }
    protoOf($).contains_3tkdvy_k$ = contains;
    protoOf($).isEmpty_y1axqb_k$ = isEmpty;
    initMetadataForClass($, 'ClosedLocalDateRange', VOID, VOID, [ClosedRange(), Iterable()], VOID, VOID, {0: $serializer_getInstance_2});
    ClosedLocalDateRangeClass = $;
  }
  return ClosedLocalDateRangeClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_5() {
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ContactInfo', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('name', true);
        tmp0_serialDesc.addElement_5pzumi_k$('email', true);
        tmp0_serialDesc.addElement_5pzumi_k$('phone', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_uliotp_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.name_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.name_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp = true;
        } else {
          var tmp_0 = value.email_1;
          tmp = !((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = EmailAddressSerializer_getInstance();
          var tmp_2 = value.email_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, tmp_1, tmp_2 == null ? null : new (EmailAddress())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.phone_1;
          tmp_3 = !((tmp_4 == null ? null : new (PhoneNumber())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = PhoneNumberSerializer_getInstance();
          var tmp_6 = value.phone_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (PhoneNumber())(tmp_6));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_uliotp_k$(encoder, value instanceof ContactInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = EmailAddressSerializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (EmailAddress())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = PhoneNumberSerializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (PhoneNumber())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ContactInfo().new_org_thecommunitygroupinc_cares_ContactInfo_fe2ue0_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(EmailAddressSerializer_getInstance()), get_nullable(PhoneNumberSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var ContactInfoClass;
function ContactInfo() {
  if (ContactInfoClass === VOID) {
    class $ {
      constructor(name, email, phone) {
        name = name === VOID ? '' : name;
        email = email === VOID ? null : email;
        phone = phone === VOID ? null : phone;
        this.name_1 = name;
        this.email_1 = email;
        this.phone_1 = phone;
      }
      toString() {
        var tmp = this.email_1;
        var tmp_0 = toString_0(tmp == null ? null : new (EmailAddress())(tmp));
        var tmp_1 = this.phone_1;
        return 'ContactInfo(name=' + this.name_1 + ', email=' + tmp_0 + ', phone=' + toString_0(tmp_1 == null ? null : new (PhoneNumber())(tmp_1)) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.email_1;
        if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = EmailAddress__hashCode_impl_wizg9y(this.email_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.phone_1;
        if ((tmp_4 == null ? null : new (PhoneNumber())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = PhoneNumber__hashCode_impl_t98twl(this.phone_1);
        }
        result = tmp_2 + tmp_3 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContactInfo()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        var tmp = this.email_1;
        var tmp_0 = tmp == null ? null : new (EmailAddress())(tmp);
        var tmp_1 = other.email_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (EmailAddress())(tmp_1)))
          return false;
        var tmp_2 = this.phone_1;
        var tmp_3 = tmp_2 == null ? null : new (PhoneNumber())(tmp_2);
        var tmp_4 = other.phone_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (PhoneNumber())(tmp_4)))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ContactInfo_fe2ue0_k$(seen0, name, email, phone, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.name_1 = '';
        else
          $this.name_1 = name;
        if (0 === (seen0 & 2))
          $this.email_1 = null;
        else
          $this.email_1 = email;
        if (0 === (seen0 & 4))
          $this.phone_1 = null;
        else
          $this.phone_1 = phone;
        return $this;
      }
    }
    initMetadataForClass($, 'ContactInfo', ContactInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    ContactInfoClass = $;
  }
  return ContactInfoClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function AppPlatform$Companion$_anonymous__gtfl5x() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.AppPlatform', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AppPlatform_iOS_instance = new (AppPlatform())('iOS', 0, 'iOS');
  AppPlatform_Android_instance = new (AppPlatform())('Android', 1, 'Android');
  AppPlatform_Web_instance = new (AppPlatform())('Web', 2, 'Web');
  AppPlatform_Desktop_instance = new (AppPlatform())('Desktop', 3, 'Desktop');
  if (Companion_instance_4 === VOID) {
    Companion_instance;
    new (Companion_3())();
  }
}
var AppPlatform_iOS_instance;
var AppPlatform_Android_instance;
var AppPlatform_Web_instance;
var AppPlatform_Desktop_instance;
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, AppPlatform$Companion$_anonymous__gtfl5x);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_6() {
  static_init();
  return Companion_instance_4;
}
function values() {
  static_init();
  return [AppPlatform_iOS_getInstance(), AppPlatform_Android_getInstance(), AppPlatform_Web_getInstance(), AppPlatform_Desktop_getInstance()];
}
var AppPlatformClass;
function AppPlatform() {
  if (AppPlatformClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'AppPlatform', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    AppPlatformClass = $;
  }
  return AppPlatformClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_7() {
  return Companion_instance_5;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Address', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('line1', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('lines'));
        tmp0_serialDesc.addElement_5pzumi_k$('line2', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('lines'));
        tmp0_serialDesc.addElement_5pzumi_k$('city', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('citystate'));
        tmp0_serialDesc.addElement_5pzumi_k$('state', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('citystate'));
        tmp0_serialDesc.addElement_5pzumi_k$('postalCode', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Group())('citystate'));
        tmp0_serialDesc.addElement_5pzumi_k$('geo', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_49xn53_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.line1__1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.line2__1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.line2__1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.city_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.state_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.postalCode_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.postalCode_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.geo_1.equals(new (GeoCoordinate())(0.0, 0.0))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, GeoCoordinateGeoJsonSerializer_getInstance(), value.geo_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_49xn53_k$(encoder, value instanceof Address() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, GeoCoordinateGeoJsonSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, GeoCoordinateGeoJsonSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Address().new_org_thecommunitygroupinc_cares_Address_jdei4f_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), GeoCoordinateGeoJsonSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var AddressClass;
function Address() {
  if (AddressClass === VOID) {
    class $ {
      constructor(line1, line2, city, state, postalCode, geo) {
        line2 = line2 === VOID ? '' : line2;
        postalCode = postalCode === VOID ? '' : postalCode;
        geo = geo === VOID ? new (GeoCoordinate())(0.0, 0.0) : geo;
        this.line1__1 = line1;
        this.line2__1 = line2;
        this.city_1 = city;
        this.state_1 = state;
        this.postalCode_1 = postalCode;
        this.geo_1 = geo;
      }
      toString() {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = listOf([this.state_1, this.postalCode_1]);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.add_utx5q5_k$(element);
          }
        }
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = listOf([this.line1__1, this.line2__1, this.city_1, joinToString(destination, ' ')]);
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_0.add_utx5q5_k$(element_0);
          }
        }
        return joinToString(destination_0, ', ');
      }
      toCityState_srlsgl_k$() {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = listOf([this.city_1, this.state_1]);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.add_utx5q5_k$(element);
          }
        }
        return joinToString(destination, ', ');
      }
      hashCode() {
        var result = getStringHashCode(this.line1__1);
        result = imul(result, 31) + getStringHashCode(this.line2__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.city_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.state_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.postalCode_1) | 0;
        result = imul(result, 31) + this.geo_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Address()))
          return false;
        if (!(this.line1__1 === other.line1__1))
          return false;
        if (!(this.line2__1 === other.line2__1))
          return false;
        if (!(this.city_1 === other.city_1))
          return false;
        if (!(this.state_1 === other.state_1))
          return false;
        if (!(this.postalCode_1 === other.postalCode_1))
          return false;
        if (!this.geo_1.equals(other.geo_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Address_jdei4f_k$(seen0, line1, line2, city, state, postalCode, geo, serializationConstructorMarker) {
        if (!(13 === (13 & seen0))) {
          throwMissingFieldException(seen0, 13, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        $this.line1__1 = line1;
        if (0 === (seen0 & 2))
          $this.line2__1 = '';
        else
          $this.line2__1 = line2;
        $this.city_1 = city;
        $this.state_1 = state;
        if (0 === (seen0 & 16))
          $this.postalCode_1 = '';
        else
          $this.postalCode_1 = postalCode;
        if (0 === (seen0 & 32))
          $this.geo_1 = new (GeoCoordinate())(0.0, 0.0);
        else
          $this.geo_1 = geo;
        return $this;
      }
    }
    initMetadataForClass($, 'Address', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    AddressClass = $;
  }
  return AddressClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function RaceOrEthnicity$Companion$_anonymous__vigr3w() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.RaceOrEthnicity', values_0());
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  RaceOrEthnicity_AmericanIndianOrAlaskaNative_instance = new (RaceOrEthnicity())('AmericanIndianOrAlaskaNative', 0, 'American Indian or Alaska Native');
  RaceOrEthnicity_Asian_instance = new (RaceOrEthnicity())('Asian', 1, 'Asian');
  RaceOrEthnicity_BlackOrAfricanAmerican_instance = new (RaceOrEthnicity())('BlackOrAfricanAmerican', 2, 'Black or African American');
  RaceOrEthnicity_HispanicOrLatino_instance = new (RaceOrEthnicity())('HispanicOrLatino', 3, 'Hispanic or Latino');
  RaceOrEthnicity_MiddleEasternOrNorthAfrican_instance = new (RaceOrEthnicity())('MiddleEasternOrNorthAfrican', 4, 'Middle Eastern or North African');
  RaceOrEthnicity_NativeHawaiianOrOtherPacificIslander_instance = new (RaceOrEthnicity())('NativeHawaiianOrOtherPacificIslander', 5, 'Native Hawaiian or Other Pacific Islander');
  RaceOrEthnicity_White_instance = new (RaceOrEthnicity())('White', 6, 'White');
  if (Companion_instance_6 === VOID) {
    Companion_instance;
    new (Companion_5())();
  }
}
var RaceOrEthnicity_AmericanIndianOrAlaskaNative_instance;
var RaceOrEthnicity_Asian_instance;
var RaceOrEthnicity_BlackOrAfricanAmerican_instance;
var RaceOrEthnicity_HispanicOrLatino_instance;
var RaceOrEthnicity_MiddleEasternOrNorthAfrican_instance;
var RaceOrEthnicity_NativeHawaiianOrOtherPacificIslander_instance;
var RaceOrEthnicity_White_instance;
function values_0() {
  static_init_0();
  return [RaceOrEthnicity_AmericanIndianOrAlaskaNative_getInstance(), RaceOrEthnicity_Asian_getInstance(), RaceOrEthnicity_BlackOrAfricanAmerican_getInstance(), RaceOrEthnicity_HispanicOrLatino_getInstance(), RaceOrEthnicity_MiddleEasternOrNorthAfrican_getInstance(), RaceOrEthnicity_NativeHawaiianOrOtherPacificIslander_getInstance(), RaceOrEthnicity_White_getInstance()];
}
function get_entries() {
  static_init_0();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, RaceOrEthnicity$Companion$_anonymous__vigr3w);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_8() {
  static_init_0();
  return Companion_instance_6;
}
var $ENTRIES;
var RaceOrEthnicityClass;
function RaceOrEthnicity() {
  if (RaceOrEthnicityClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'RaceOrEthnicity', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    RaceOrEthnicityClass = $;
  }
  return RaceOrEthnicityClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Gender$Companion$_anonymous__94378y() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.Gender', values_1());
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  Gender_Male_instance = new (Gender())('Male', 0, 'Male');
  Gender_Female_instance = new (Gender())('Female', 1, 'Female');
  if (Companion_instance_7 === VOID) {
    Companion_instance;
    new (Companion_6())();
  }
}
var Gender_Male_instance;
var Gender_Female_instance;
function values_1() {
  static_init_1();
  return [Gender_Male_getInstance(), Gender_Female_getInstance()];
}
function get_entries_0() {
  static_init_1();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_1());
  return $ENTRIES_0;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Gender$Companion$_anonymous__94378y);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_9() {
  static_init_1();
  return Companion_instance_7;
}
var $ENTRIES_0;
var GenderClass;
function Gender() {
  if (GenderClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'Gender', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    GenderClass = $;
  }
  return GenderClass;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Language$Companion$_anonymous__cu7ktz() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.Language', values_2());
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  Language_English_instance = new (Language())('English', 0);
  Language_Spanish_instance = new (Language())('Spanish', 1);
  Language_Portuguese_instance = new (Language())('Portuguese', 2);
  if (Companion_instance_8 === VOID) {
    Companion_instance;
    new (Companion_7())();
  }
}
var Language_English_instance;
var Language_Spanish_instance;
var Language_Portuguese_instance;
function values_2() {
  static_init_2();
  return [Language_English_getInstance(), Language_Spanish_getInstance(), Language_Portuguese_getInstance()];
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Language$Companion$_anonymous__cu7ktz);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_10() {
  static_init_2();
  return Companion_instance_8;
}
var LanguageClass;
function Language() {
  if (LanguageClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Language', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_10});
    LanguageClass = $;
  }
  return LanguageClass;
}
function get_abbreviation(_this__u8e3s4) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.text.replaceFirstChar' call
  var this_0 = take(_this__u8e3s4.name_1, 3).toLowerCase();
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    // Inline function 'kotlin.text.uppercase' call
    var this_1 = charCodeAt(this_0, 0);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$4 = toString_1(this_1).toUpperCase();
    tmp = toString(tmp$ret$4) + substring(this_0, 1);
  } else {
    tmp = this_0;
  }
  return tmp;
}
function get_displayName(_this__u8e3s4) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.text.replaceFirstChar' call
  var this_0 = _this__u8e3s4.name_1.toLowerCase();
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    // Inline function 'kotlin.text.uppercase' call
    var this_1 = charCodeAt(this_0, 0);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$4 = toString_1(this_1).toUpperCase();
    tmp = toString(tmp$ret$4) + substring(this_0, 1);
  } else {
    tmp = this_0;
  }
  return tmp;
}
function AppPlatform_iOS_getInstance() {
  static_init();
  return AppPlatform_iOS_instance;
}
function AppPlatform_Android_getInstance() {
  static_init();
  return AppPlatform_Android_instance;
}
function AppPlatform_Web_getInstance() {
  static_init();
  return AppPlatform_Web_instance;
}
function AppPlatform_Desktop_getInstance() {
  static_init();
  return AppPlatform_Desktop_instance;
}
function RaceOrEthnicity_AmericanIndianOrAlaskaNative_getInstance() {
  static_init_0();
  return RaceOrEthnicity_AmericanIndianOrAlaskaNative_instance;
}
function RaceOrEthnicity_Asian_getInstance() {
  static_init_0();
  return RaceOrEthnicity_Asian_instance;
}
function RaceOrEthnicity_BlackOrAfricanAmerican_getInstance() {
  static_init_0();
  return RaceOrEthnicity_BlackOrAfricanAmerican_instance;
}
function RaceOrEthnicity_HispanicOrLatino_getInstance() {
  static_init_0();
  return RaceOrEthnicity_HispanicOrLatino_instance;
}
function RaceOrEthnicity_MiddleEasternOrNorthAfrican_getInstance() {
  static_init_0();
  return RaceOrEthnicity_MiddleEasternOrNorthAfrican_instance;
}
function RaceOrEthnicity_NativeHawaiianOrOtherPacificIslander_getInstance() {
  static_init_0();
  return RaceOrEthnicity_NativeHawaiianOrOtherPacificIslander_instance;
}
function RaceOrEthnicity_White_getInstance() {
  static_init_0();
  return RaceOrEthnicity_White_instance;
}
function Gender_Male_getInstance() {
  static_init_1();
  return Gender_Male_instance;
}
function Gender_Female_getInstance() {
  static_init_1();
  return Gender_Female_instance;
}
function Language_English_getInstance() {
  static_init_2();
  return Language_English_instance;
}
function Language_Spanish_getInstance() {
  static_init_2();
  return Language_Spanish_instance;
}
function Language_Portuguese_getInstance() {
  static_init_2();
  return Language_Portuguese_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_5 = new (Companion_4())();
//endregion
//region block: exports
export {
  AppPlatform_Android_getInstance as AppPlatform_Android_getInstanceoi5cw4duvk8g,
  AppPlatform_Desktop_getInstance as AppPlatform_Desktop_getInstancewuln9i6vat0d,
  AppPlatform_Web_getInstance as AppPlatform_Web_getInstance10fsaay04fbhg,
  AppPlatform_iOS_getInstance as AppPlatform_iOS_getInstancen6zsnixoh3w2,
  Language_English_getInstance as Language_English_getInstance3fal8680h6i1g,
  Language_Portuguese_getInstance as Language_Portuguese_getInstance1agxjt5hifvlp,
  Language_Spanish_getInstance as Language_Spanish_getInstance2ph1da8p4vhrr,
  $serializer_getInstance_4 as $serializer_getInstance1m3cbcq74wr1,
  Companion_instance_5 as Companion_instancen1zs0vnqjbin,
  Companion_getInstance_6 as Companion_getInstance386m8xfiehsti,
  $serializer_getInstance_2 as $serializer_getInstanceva225auct2k8,
  Companion_instance_2 as Companion_instance1a4q68acbdhgb,
  $serializer_getInstance_3 as $serializer_getInstance36a6xm1fkegaj,
  Companion_instance_3 as Companion_instanceqxewwv101ea8,
  Companion_getInstance_9 as Companion_getInstance18374pr9rm3ox,
  Companion_getInstance_10 as Companion_getInstanceapne0fh8g5sn,
  $serializer_getInstance_0 as $serializer_getInstancegx2p6odi22tj,
  Companion_instance_0 as Companion_instance1eu9vz7wcioa,
  Companion_getInstance_8 as Companion_getInstancec4abf6gzvhv2,
  $serializer_getInstance_1 as $serializer_getInstance2ga0n7x7no2vd,
  Companion_getInstance_3 as Companion_getInstance2n667ht97uzau,
  Address as Addresspdncepxooezp,
  ClosedLocalDateRange as ClosedLocalDateRange6599xgap66zd,
  ContactInfo as ContactInfo1q5ur6ox19zr5,
  get_entries_0 as get_entries1h5lbabcw0nnn,
  LocalDateRange as LocalDateRangefowoyqa24icz,
  get_entries as get_entries3daovqa75g4uq,
  RecordedAction as RecordedAction2zjpqvlfzzos,
};
//endregion

//# sourceMappingURL=types.mjs.map
